import React, { FunctionComponent } from "react";

import { NavigationSection } from "../../navigation";
import { MenuItemActivatedType } from "../../types";
import { createItemIdForProfile } from "../../utils";
import { ActionMenu } from "../ActionMenu";
import { FavoriteActionItem } from "../FavoriteActionItem";
import { OpenActionItem } from "../OpenActionItem";
import { OpenInTabActionItem } from "../OpenInTabActionItem";

export type ProfileRightPartComponentProps = {
    /** Viz. dokumentace v ActionMenu. */
    isActive?: boolean;
    /** Indikátor, zda je zaměřená některá akční položka. */
    isActionItemFocused: boolean;
    /** Id formuláře pod kterým je profil vykreslený, pokud není profil vykreslený samostatně. */
    parentFormItemId?: number;
    /** Povoluje zobrazení akcí otevírajících novou instanci formuláře s profilem. */
    windowActionsEnabled: boolean;
    /** Příznak umožňující povolit/zakázat zobrazení kontextové akce pro otevření. */
    openActionEnabled: boolean;
    /** Sekce, ve které je komponenta vykreslená. Slouží pro určování zaměření. */
    section: NavigationSection;
    /** Id profilu */
    profileId: number;
};

/** Komponenta slouží jako pravá část pro položky v menu, které představují profil formuláře. */
export const ProfileRightPartComponent: FunctionComponent<ProfileRightPartComponentProps> = ({
    isActive,
    isActionItemFocused,
    windowActionsEnabled,
    openActionEnabled,
    section,
    profileId,
    parentFormItemId,
}) => {
    if (!windowActionsEnabled) {
        return null;
    }

    const itemId = createItemIdForProfile(profileId, parentFormItemId);
    const actions = [];
    if (parentFormItemId && profileId) {
        actions.push(
            <FavoriteActionItem key="favoriteAction" itemId={parentFormItemId} activatableItemType={MenuItemActivatedType.formFavoriteActionItem} section={section} profileId={profileId}/>,
        );
    }
    if (openActionEnabled) {
        actions.push(
            <OpenActionItem key="openAction" {...{ itemId, section }} activatableItemType={MenuItemActivatedType.openProfileActionItem} />,
        );
    }
    actions.push(
        <OpenInTabActionItem key="openInTabAction" {...{ itemId, section }} activatableItemType={MenuItemActivatedType.openProfileInTabActionItem} />,
    );
    return (
        <ActionMenu {...{ isActive, isActionItemFocused }}>
            {actions}
        </ActionMenu>
    );
};
